module.exports = __webpack_public_path__ + "img/21CreekRoadEasment2010_1.51cbe67a.png";